<template lang="pug">
transition-group.d-flex(name="bounce", tag="ul", :style="listStyles")
  li.pr-2.d-flex.align-center(
    v-for="reaction in reactionsWithCounter",
    :key="reaction.name",
    v-if="reaction.count"
  )
    ReactionIcon(
      :count="reaction.count",
      :icon="reaction.icon",
      :size="reaction.size",
      :member-list="getMemberList(reaction.name)"
      @click="() => $emit('reaction-clicked', reaction.name)"
    )
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { ReactionOption } from "interfaces/reactionOption.interface"
import { REACTION_OPTIONS } from "constants/reactions"
import THEME from "../../constants/theme"
import ReactionIcon from "components/ReactionIcon/ReactionIcon.vue"
import { MemberReaction } from "./reaction-count.types"

const { fontFamily, fontWeightRegular } = THEME.typography
export default defineComponent({
  name: "ReactionCountFull",
  components: {
    ReactionIcon,
  },
  props: {
    topics: {
      type: Array,
      default: () => [],
    },
    likesCount: { type: Number, default: 0 },
    ideasCount: { type: Number, default: 0 },
    cheersCount: { type: Number, default: 0 },
    memberReactions: {
      type: Array as () => MemberReaction[],
      default: () => [],
    },
  },
  computed: {
    reactionOptions(): ReactionOption[] {
      return REACTION_OPTIONS.filter((option) => option.name !== "default")
    },
    reactionsWithCounter(): object[] {
      return this.reactionOptions.map((option) => {
        return {
          ...option,
          count: this.mapCountToOption(option.name),
        }
      })
    },
    listStyles() {
      return {
        listStyleType: "none",
        margin: 0,
        padding: 0,
        minHeight: "24px",
      }
    },
    listItemStyles(): object {
      return {
        fontFamily,
        fontSize: "0.8rem",
        fontWeight: fontWeightRegular,
        color: this.$vuetify.theme.themes.light.textColor,
        margin: 0,
      }
    },
    getMemberList() {
      return (icon) =>
        this.memberReactions.filter(
          (reaction: MemberReaction) => reaction.reaction === icon
        )
    },
  },
  methods: {
    mapCountToOption(optionName) {
      switch (optionName) {
        case "like":
          return this.likesCount
        case "idea":
          return this.ideasCount
        default:
          return this.cheersCount
      }
    },
  },
})
</script>

<style lang="sass" scoped>
.bounce-enter-active
  transition: opacity .2s, transform .2s ease-in-out
  transform: scale(0.9)

.bounce-leave-active
  transition: opacity 0s

.bounce-enter
  opacity: 0
  transform: scale(1.1)

.bounce-leave-to
  opacity: 0
</style>
